import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { NavigationLink } from '@stylehaven/components';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RecordNavigationService } from '../../../../services/navigation/record-navigation.service';
import { ApiFragment } from '../../../entities/api-fragment.entity';
import { BaseColumnComponent } from '../../../services/base-column-component';

@Component({
    standalone: false,
    selector: 'digihaven-parent-cell',
    templateUrl: './parent-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ParentCellComponent extends BaseColumnComponent<ApiFragment> {
    parentTitle$!: Observable<string>;
    parentNavigationLink$!: Observable<NavigationLink>;

    constructor(
        private navigationService: RecordNavigationService,
        cd: ChangeDetectorRef
    ) {
        super(cd);
        this.parentTitle$ = this.data$.pipe(map(fragment => fragment.getDirectParentTitle() ?? ''));
        this.parentNavigationLink$ = this.data$.pipe(
            map(fragment => this.navigationService.getNavigationLink({ record: fragment.getParentRecordId() ?? '' }))
        );
    }
}
